<template>
  <div class="center-shifter">
    <div class="center-shifter__input">
      <div class="center-shifter__input-line">
        <div class="center-shifter__input-label">
          <rotation-indicator :hierarchy="1" :rotation="rotation">&lambda;</rotation-indicator>
        </div>
        <ui-model-provider v-slot="{ value, updateValue }" :value.sync="lambdaRotation">
          <ui-range
            :max="180"
            :min="-180"
            :value="value"
            class="center-shifter__input-element"
            required
            type="range"
            @input="updateValue"
          />
        </ui-model-provider>
        <div class="center-shifter__input-display">
          <p>
            {{ displayNumber(lambdaRotation) }}
          </p>
        </div>
      </div>
    </div>
    <div class="center-shifter__input">
      <div class="center-shifter__input-line">
        <div class="center-shifter__input-label">
          <rotation-indicator :hierarchy="2" :rotation="rotation"> &phi;</rotation-indicator>
        </div>
        <ui-model-provider v-slot="{ value, updateValue }" :value.sync="phiRotation">
          <ui-range
            :max="180"
            :min="-180"
            :value="value"
            class="center-shifter__input-element"
            required
            type="range"
            @input="updateValue"
          />
        </ui-model-provider>
        <div class="center-shifter__input-display">
          <p>
            {{ displayNumber(phiRotation) }}
          </p>
        </div>
      </div>
    </div>
    <div class="center-shifter__input">
      <div class="center-shifter__input-line">
        <div class="center-shifter__input-label">
          <rotation-indicator :hierarchy="3" :rotation="rotation"> &gamma;</rotation-indicator>
        </div>
        <ui-model-provider v-slot="{ value, updateValue }" :value.sync="gammaRotation">
          <ui-range
            :max="180"
            :min="-180"
            :value="value"
            class="center-shifter__input-element"
            required
            type="range"
            @input="updateValue"
          />
        </ui-model-provider>
        <div class="center-shifter__input-display">
          <p>
            {{ displayNumber(gammaRotation) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UiModelProvider from '@/components/form/ui-model-provider/ui-model-provider'
  import UiRange from '@/components/form/ui-range/ui-range'
  import RotationIndicator from '@/components/rotation-indicator/rotation-indicator'

  export default {
    components: { RotationIndicator, UiRange, UiModelProvider },
    props: {
      rotation: {
        type: Array,
        required: true,
      },
    },
    computed: {
      lambdaRotation: {
        get() {
          return this.rotation[0]
        },
        set(value) {
          this.$emit('update', [value, this.phiRotation, this.gammaRotation])
        },
      },
      phiRotation: {
        get() {
          return this.rotation[1]
        },
        set(value) {
          this.$emit('update', [this.lambdaRotation, value, this.gammaRotation])
        },
      },
      gammaRotation: {
        get() {
          return this.rotation[2]
        },
        set(value) {
          this.$emit('update', [this.lambdaRotation, this.phiRotation, value])
        },
      },
    },
    methods: {
      displayNumber(num) {
        const number = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(num)

        return `${number}°`
      },
    },
  }
</script>

<style lang="scss" src="./_center-shifter.scss" />
